import { Card } from '@ui/base/card'

import { bodyText, lead, mutedText, noteText, sectionTitle } from './typography'

export type LandingStep = { title: string; text: string; note: string }

/**
 * Шаги пути пользователя: пронумерованные карточки в ряд, соединённые линией.
 *
 * `id` — якорь для липкой полосы; заголовок получает свой идентификатор, чтобы секция
 * называлась им для программ чтения с экрана.
 */
export const LandingSteps = ({
  id,
  intro,
  items,
  title,
}: {
  id: string
  intro: string
  items: LandingStep[]
  title: string
}) => (
  <section aria-labelledby={`${id}-title`} className="scroll-mt-20 pt-14 pb-12 lg:pt-20 lg:pb-16" id={id}>
    <h2 id={`${id}-title`} className={sectionTitle}>
      {title}
    </h2>
    <p className={`${lead} ${mutedText} mt-2 mb-10 max-w-[60ch]`}>{intro}</p>

    <div className="relative">
      {/* Линия связывает номера шагов между собой. Она лежит вне списка: пустой пункт добавил бы
          программе чтения с экрана лишний шаг. На узком экране карточки идут столбиком,
          и линия проходила бы поперёк текста — там её нет. */}
      <div
        aria-hidden="true"
        className="absolute top-[44px] right-[8%] left-[8%] hidden h-px lg:block"
        style={{
          backgroundImage:
            'linear-gradient(90deg, color-mix(in srgb, var(--primary) 35%, transparent), color-mix(in srgb, var(--primary) 12%, transparent))',
        }}
      />
      <ol className="grid gap-5 lg:grid-cols-3">
        {items.map((step, index) => (
          <li key={step.title} className="relative">
            <Card className="h-full gap-3 px-6 pt-6 pb-7">
              <span className="bg-primary text-primary-foreground flex size-[38px] items-center justify-center rounded-xl text-[16px] font-semibold tabular-nums shadow-[0_6px_16px_color-mix(in_srgb,var(--primary)_30%,transparent)]">
                {index + 1}
              </span>
              <h3 className="mt-1 text-[20px] leading-[1.3] font-semibold tracking-[-0.012em]">{step.title}</h3>
              <p className={`${bodyText} ${mutedText}`}>{step.text}</p>
              <span className={`${noteText} text-muted-foreground mt-auto pt-2`}>{step.note}</span>
            </Card>
          </li>
        ))}
      </ol>
    </div>
  </section>
)
